<template>
  <div class="bg-white">
    <h5>Novo Usuário</h5>
    <p class="login-description text-muted mt-2 mb-5">
      Entre com seus dados para criar um novo acesso a plataforma Êxitos. Você
      terá 7 dias de experiência na ferramenta e pode ativar todos os recursos
      oferecidos a qualquer momento.
    </p>
    <form @submit.prevent="submit()">
      <b-form-group label="Nome:">
        <b-form-input
          v-model="form.name"
          placeholder="Nome"
          :state="validateState('name')"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.form.email.required"
            >E-mail é um campo obrigatório.</span
          >
          <span v-if="!$v.form.email.email">E-mail inválido</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="E-mail:">
        <b-form-input
          v-model="form.email"
          placeholder="E-mail"
          :state="validateState('email')"
        ></b-form-input>
        <b-form-invalid-feedback>
          <span v-if="!$v.form.email.required"
            >E-mail é um campo obrigatório.</span
          >
          <span v-if="!$v.form.email.email">E-mail inválido</span>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Senha:">
        <b-input-group class="login-pass">
          <b-form-input
            v-model="form.password"
            :state="validateState('password')"
            placeholder="Senha"
            type="password"
            class="input-pass"
          ></b-form-input>

          <b-input-group-append>
            <b-button
              class="button-show-pass"
              :state="validateState('password')"
              @click="show_pass = !show_pass"
            >
              <font-awesome-icon icon="eye" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :state="validateState('password')">
          <span v-if="!$v.form.password.minLength">Senha é obrigatório.</span>
        </b-form-invalid-feedback>
        <b-form-text>
          <span v-if="show_pass">{{ form.password }}</span>
          &nbsp;</b-form-text
        >
      </b-form-group>

      <b-row class="login-actions">
        <b-col cols="auto" class="mr-auto"
          ><router-link :to="{ name: 'login' }">Voltar </router-link></b-col
        >
        <b-col cols="auto"
          ><button class="btn login-button">
            Enviar <span class="material-icons"> arrow_right_alt </span>
          </button></b-col
        >
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: "",
      email: "",
      password: "",
    },
    show_pass: false,
    error_message: "",
  }),
  validations: {
    form: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  computed: {},
  methods: {
    ...mapActions("auth", ["ActionDoLogin"]),
    async submit() {
      this.error_message = "";

      try {
        this.$v.$touch();
        if (!this.$v.$anyError) {
          await this.ActionDoLogin(this.form);
          this.$router.push({ name: "login" });
        }
      } catch (err) {
        this.error_message =
          err.data && err.data.message
            ? err.data.message
            : "Não foi possível fazer login";
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
